/**
 * TableReport — обёртка над ReportTable с фильтрами
 * 
 * Используется для страниц отчётов с пагинацией:
 * - /reports/users
 * - /reports/session
 * - /reports/payments
 * - и другие страницы CRM
 * 
 * Для дашбордов и отчётов с группировками используйте:
 * - report-table/ReportTable (для ad-reports, webinar-reports, payment-reports, order-reports)
 * - dashboards/Table (UniversalTable) для дашбордов
 * 
 * @see report-table/ReportTable для отчётов с группировками
 * @see dashboards/Table для дашбордов
 */
import { FC, useEffect, useMemo, useRef, useState } from 'react';

import { useLocation } from 'react-router-dom';

import ReportTable from './table/ReportTable';
import { useActions } from '../../../hooks/useActions';
import { useTypedSelector } from '../../../hooks/useTypedSelector';
import Loader from '../../loader/Loader';
import Filter from '../params/filter';

interface IReportProps {
    /** Метрики для отображения */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    metrics: any[];
    /** URL API для загрузки данных */
    apiUrl: string;
    /** Фильтры для скрытия */
    filtersFilter?: string[];
    /** Показывать сегменты */
    withSegment?: boolean;
    /** Показывать фильтры */
    withFilter?: boolean;
    /** Кастомные колонки */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    customColumns?: any[];
    defaultSort?: Record<string, 'ASC' | 'DESC'>;
}

const TableReport: FC<IReportProps> = ({ metrics, apiUrl,customColumns, filtersFilter, withSegment = true, withFilter = true, defaultSort = {} }) => {
    const isMountRef = useRef(true);
    const [ loadingTable, setLoadingTable ] = useState(false);
    const [ btnDisabled, setBtnDisabled ] = useState(true);
    const { setFilters, setFiltersTable, setCurrentReport, setCurrentSegment, setSortTable } = useActions();
    const {  isLoading: isLoadingAds  } = useTypedSelector(
        (state) => state.adsCabinet
    );
    const { filter, period, details: storeDetails } = useTypedSelector((state) => state);
    const locationState = useLocation();

    useEffect(() => {
        setFilters([]);
        setFiltersTable([]);
        setSortTable(defaultSort);
        setCurrentReport({});
        setCurrentSegment(null);
    }, []);

    useEffect(() => {
        if (isMountRef.current){
            isMountRef.current = false;
            return;
        }
        setBtnDisabled(false);
    },[filter.currentSegment, filter.filters])

    const loading = useMemo(()=>{
        const isFirstTab = !locationState.search.includes('tab=2');
        const isRkPages = (locationState.pathname.includes('/source/ads') || locationState.pathname.includes('/advert/rate'))  && isFirstTab;
        if(isRkPages){
            return isLoadingAds;
        }
        return loadingTable;
    },[ isLoadingAds,loadingTable,locationState ]);

    return (
        <div data-help-id="report-table" className="tableContainer">
            <Loader loading={loading}>
                {
                    withFilter ?
                        <Filter
                            filtersFilter={filtersFilter}
                            isCompare={false}
                            withSegment={withSegment}
                            reqBtnDisabled={btnDisabled}
                            setReqBtnDisabled={setBtnDisabled}
                        />
                        : null
                }

                <ReportTable
                    apiUrl={apiUrl}
                    loadingTable={loading}
                    setLoadingTable={setLoadingTable}
                    externalMetrics={metrics}
                    customColumns={customColumns}
                />
            </Loader>
        </div>
    );
};

export default TableReport;
